import { getTheme } from './features/multi-tenancy/theme';

if (getTheme() === 'rio') {
    delete document.documentElement.dataset.brand;
    document.querySelector('title')!.innerHTML = 'RIO SCM';
}

import('./appBootstrap').then(({ appBootstrap }) => appBootstrap());
